import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/private/services/api.service';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class EmailHubService {

  constructor(private api: ApiService) { }

  getOutlookInboxEmail(data:any): Observable<any> {
    return this.api.post(environment.outlookInboxEmail,data);
  }

  getOutlookSentEmail(data:any): Observable<any> {
    return this.api.post(environment.outlookSentEmail,data);
  }

  getOutlookDraftEmail(data:any): Observable<any> {
    return this.api.post(environment.outlookDraftEmail,data);
  }

  getOutlookTrashEmail(data:any): Observable<any> {
    return this.api.post(environment.outlookJunkEmail,data);
  }

 

  deleteOutlookEmail(data:any): Observable<any> {
    return this.api.post(environment.deleteOutlookEmail,data);
  }

  deleteOutlookEmailPermanently(data:any): Observable<any> {
    return this.api.post(environment.deleteOutlookEmailPermanently,data);
  }

  getOutlookDeletedEmail(data:any): Observable<any> {
    return this.api.post(environment.outlookDeletedEmail,data);
  }

  sendEmailUsingOutlook(data:any): Observable<any> {
    return this.api.post(environment.sendEmailUsingOutlook,data);
  }

  sendOutlookDraftEmail(data:any): Observable<any> {
    return this.api.post(environment.sendOutlookDraftEmail,data);
  }

  getOutlookEmailWithAttachment(data:any): Observable<any> {
    return this.api.post(environment.getOutlookEmailWithAttachment,data);
  }

  createOutlookDraftEmail(data:any): Observable<any> {
    return this.api.post(environment.createOutlookDraftEmail,data);
  }

  updateOutlookDraftEmail(data:any): Observable<any> {
    return this.api.post(environment.updateOutlookDraftEmail,data);
  }

  createOutlookReply(data:any): Observable<any> {
    return this.api.post(environment.createOutlookReply,data);
  }

  createOutlookReplyAll(data:any): Observable<any> {
    return this.api.post(environment.createOutlookReplyAll,data);
  }

  sendOutlookReply(data:any): Observable<any> {
    return this.api.post(environment.sendOutlookReply,data);
  }

  forwardOutlookEmail(data:any): Observable<any> {
    return this.api.post(environment.forwardOutlookEmail,data);
  }

  getOutlookEmailAttachments(data:any): Observable<any> {
    return this.api.post(environment.getOutlookEmailAttachments,data);
  }

  addAttachmentInOutlookReply(data:any): Observable<any> {
    return this.api.post(environment.addAttachmentInOutlookReply,data);
  }

  deleteAttachmentInOutlook(data:any): Observable<any> {
    return this.api.post(environment.deleteAttachmentInOutlook,data);
  }
  

  getCodeForOutlookToken(data:any): Observable<any> {
    return this.api.post(environment.getCodeForOutlookToken, data);
  }

  revokeAccess(data:any): Observable<any> {
    return this.api.post(environment.revokeAccess, data);
  }

  getConnectedOutlookEmail(data:any): Observable<any> {
    return this.api.post(environment.getConnectedOutlookEmail, data);
  }

  /* ---------- Gmail mail hub (part-d) ---------- */
  getGmailInboxEmail(data: any): Observable<any> {
    return this.api.post(environment.gmailInboxEmail, data);
  }
  getGmailSentEmail(data: any): Observable<any> {
    return this.api.post(environment.gmailSentEmail, data);
  }
  getGmailDraftEmail(data: any): Observable<any> {
    return this.api.post(environment.gmailDraftEmail, data);
  }
  getGmailSpamEmail(data: any): Observable<any> {
    return this.api.post(environment.gmailSpamEmail, data);
  }
  getGmailTrashEmail(data: any): Observable<any> {
    return this.api.post(environment.gmailTrashEmail, data);
  }
  sendEmailUsingGmail(data: any): Observable<any> {
    return this.api.post(environment.sendEmailUsingGmail, data);
  }
  deleteGmailEmail(data: any): Observable<any> {
    return this.api.post(environment.deleteGmailEmail, data);
  }
  deleteGmailEmailPermanently(data: any): Observable<any> {
    return this.api.post(environment.deleteGmailEmailPermanently, data);
  }
  getGmailEmailWithAttachment(data: any): Observable<any> {
    return this.api.post(environment.getGmailEmailWithAttachment, data);
  }
  createGmailDraftEmail(data: any): Observable<any> {
    return this.api.post(environment.createGmailDraftEmail, data);
  }
  updateGmailDraftEmail(data: any): Observable<any> {
    return this.api.post(environment.updateGmailDraftEmail, data);
  }
  sendGmailDraftEmail(data: any): Observable<any> {
    return this.api.post(environment.sendGmailDraftEmail, data);
  }
  deleteGmailDraftEmail(data: any): Observable<any> {
    return this.api.post(environment.deleteGmailDraftEmail, data);
  }
  createGmailReplyDraft(data: any): Observable<any> {
    return this.api.post(environment.createGmailReplyDraft, data);
  }
  createGmailReplyAllDraft(data: any): Observable<any> {
    return this.api.post(environment.createGmailReplyAllDraft, data);
  }
  sendGmailReplyEmail(data: any): Observable<any> {
    return this.api.post(environment.sendGmailReplyEmail, data);
  }
  forwardGmailEmail(data: any): Observable<any> {
    return this.api.post(environment.forwardGmailEmail, data);
  }
  getGmailEmailAttachments(data: any): Observable<any> {
    return this.api.post(environment.getGmailEmailAttachments, data);
  }
  getConnectedGmailEmail(data: any): Observable<any> {
    return this.api.post(environment.getConnectedGmailEmail, data);
  }
  /** Plain JSON to part-d (handler not in secureAllHandlers); EncryptionInterceptor skips cipher for this URL. */
  getCodeForGoogleToken(data: any): Observable<any> {
    return this.api.post(environment.getCodeForGoogleToken, data);
  }
  disconnectGmail(data: any): Observable<any> {
    return this.api.post(environment.disconnectGmail, data);
  }
}

